<template>
  <div class="SearchBarContainer">
    <div class="searchContainer">
      <div class="searchInput leftCenter">
        <input type="text" placeholder="请输入地点..." v-model="query.name" @change="onSearchName">
        <img src="../../assets/image/search.png" />
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "SearchBar",
  data() {
    return {
      query: {
        name:null,
        departmentId:null,
      },
      regionMap: {},
    }
  },
  methods: {
    onSearchName(){
      this.$emit('search', this.query)
    }
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>
input:focus {
  outline: none;
}

.SearchBarContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: $smallerFontSize;

  .searchContainer {
    margin: 16px 0;
    background-color: white;
    border-radius: 12px;
    padding: 4px 16px 4px 4px;
    display: flex;
    flex-direction: column;


    .selector {
      font-size: $smallerFontSize;
    }

    .divider {
      height: 1px;
      background-color: #eae9e9;
      width: 100%;
      margin: 8px 0;
    }

    .searchInput {
      input {
        margin-left: 5%;
        width: 95%;
        border: none;
      }
    }
    img{
      width: 15px;
      height: 15px;
    }
  }
}
</style>